<template>

  <div class="modal-dim " :class="{on:  on}">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal ">
          <header class="header">
            <div class="inner">
              <h1 class="ttl">페이지 제목 길어질 시 말줄임 됩니다. 페이지 제목 길어질 시 말줄임 됩니다.</h1>
              <div class="right">
                <button class="header-btn" @click="cancel"><i class="ico-close"></i></button>
              </div>
            </div>
          </header>
          <div class="modal-con">
            <div class="modal-txt">
              <div class="txt-con">
                <p v-html="contents"></p>
              </div>
            </div>
          </div>
          <div class="modal-btn" v-if="cancelText || doneText">
            <div class="btn-wrap">
              <button class="btn bo" @click="cancel" v-if="cancelText">
                {{ cancelText }}
              </button>
              <button class="btn" @click="done" v-if="doneText">
                {{ doneText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, toRefs } from 'vue';

const props = defineProps(['data'])
const {title, contents, doneText, cancelText}=toRefs(props.data)
const {doneCallback, cancelCallback} = props.data
console.log(props);
const emits = defineEmits(['close'])

onMounted(()=>addOn())
const on = ref(false)
const cancel = () => {
  if(cancelCallback) cancelCallback()
  removeOn()
}
const done = ( ) => {
  if(doneCallback) doneCallback()
  removeOn()
}
const addOn = () => {
  const timeout = setTimeout(( )=>{
    clearTimeout(timeout)
    on.value = true
  },500)
}
const removeOn = () => {
  on.value=false
  setTimeout(() => {
    emits('close')
  }, 500)
}
</script>

<style scoped></style>
